﻿// @ts-nocheck
// invoices + jobs + payments + email

// ========== Invoice Generator ==========
function aiGenerateInvoice(month, projectName) {
  // Set the dropdowns to the specified values
  const invoiceMonthSelect = document.getElementById("invoiceMonthSelect");
  const invoiceClientSelect = document.getElementById("invoiceClientSelect");
  
  if (invoiceMonthSelect) {
    invoiceMonthSelect.value = month;
    // Trigger change event to populate clients
    invoiceMonthSelect.dispatchEvent(new Event("change"));
  }
  
  // Small delay to allow client dropdown to populate
  setTimeout(() => {
    if (invoiceClientSelect) {
      invoiceClientSelect.value = projectName;
    }
    
    // Generate the invoice
    setTimeout(() => {
      generateInvoice();
      
      // Switch to Tools tab
      switchTab("tools");
    }, 100);
  }, 100);
}

function populateInvoiceMonths() {
  const select = document.getElementById("invoiceMonthSelect");
  if (!select) return;
  
  const monthlySummary = getMonthlySummary();
  const months = Object.keys(monthlySummary).sort().reverse();
  
  if (months.length === 0) {
    select.innerHTML = '<option value="">– No data yet –</option>';
    return;
  }
  
  select.innerHTML = '<option value="">– Select month –</option>';
  months.forEach((month) => {
    const option = document.createElement("option");
    option.value = month;
    const [year, monthNum] = month.split("-");
    const monthName = new Date(year, parseInt(monthNum) - 1).toLocaleString("default", { month: "short", year: "numeric" });
    option.textContent = monthName;
    select.appendChild(option);
  });
}

function populateInvoiceClients() {
  const invoiceMonthSelect = document.getElementById("invoiceMonthSelect");
  const invoiceClientSelect = document.getElementById("invoiceClientSelect");
  const month = invoiceMonthSelect?.value;
  
  if (!month || !invoiceClientSelect) return;
  
  const projectBreakdown = getProjectBreakdown(month);
  const projects = Object.keys(projectBreakdown);
  
  if (projects.length === 0) {
    invoiceClientSelect.innerHTML = '<option value="">– No clients –</option>';
    return;
  }
  
  invoiceClientSelect.innerHTML = '<option value="">– Select client –</option>';
  projects.forEach((projectName) => {
    const option = document.createElement("option");
    option.value = projectName;
    option.textContent = projectName;
    invoiceClientSelect.appendChild(option);
  });

  const selectedProject = invoiceClientSelect.value;
  if (selectedProject) setInvoiceStateFromProject(selectedProject);
}

async function saveCurrentInvoiceRecord(invoice) {
  if (!invoice) return;
  const response = await fetchWithAuth("/api/invoices", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(invoice),
  });
  if (!response.ok) {
    console.error("Failed to save invoice record");
    return;
  }
  await loadInvoices();
}

async function loadInvoices() {
  const container = document.getElementById("invoiceHistoryList");
  if (!container) return;
  try {
    const response = await fetchWithAuth("/api/invoices");
    if (!response.ok) throw new Error("Failed to load invoices");
    const payload = await response.json();
    invoices = Array.isArray(payload) ? payload : (payload.invoices || []);
    renderInvoiceHistory();
    if (typeof renderServiceDashboardOverview === "function") renderServiceDashboardOverview();
  } catch (err) {
    container.innerHTML = "<p class='small-text'>Could not load invoice history.</p>";
  }
}

async function loadJobs() {
  const container = document.getElementById("dispatchBoard");
  if (!container) return;
  try {
    const response = await fetchWithAuth("/api/jobs");
    if (!response.ok) throw new Error("Failed to load jobs");
    const payload = await response.json();
    jobs = Array.isArray(payload) ? payload : (payload.jobs || []);
    renderDispatchBoard();
    if (typeof renderServiceDashboardOverview === "function") renderServiceDashboardOverview();
  } catch (err) {
    container.innerHTML = "<p class='small-text'>Could not load jobs.</p>";
  }
}

function renderDispatchBoard() {
  const container = document.getElementById("dispatchBoard");
  if (!container) return;
  const columns = [
    { key: "backlog", label: "Backlog" },
    { key: "scheduled", label: "Scheduled" },
    { key: "in_progress", label: "In Progress" },
    { key: "done", label: "Done" },
  ];

  const html = columns.map((col) => {
    const items = jobs.filter((j) => j.status === col.key);
    const cards = items.map((job) => {
      const isLinked = !!job.appointmentId;
      const linkedAppt = isLinked ? appointments.find((a) => a.id === job.appointmentId) : null;
      const linkedPriceTag = linkedAppt ? `<span style="font-weight:600; color:var(--success, #10b981);">$${Number(linkedAppt.price).toFixed(2)}</span>` : "";
      const flatPriceTag = !linkedAppt && Number.isFinite(Number(job.flatAmount)) && Number(job.flatAmount) > 0
        ? `<span style="font-weight:600; color:var(--success, #10b981);">$${Number(job.flatAmount).toFixed(2)}</span>` : "";
      const calBadge = isLinked ? `<span title="Linked to Schedule appointment" style="font-size:0.7rem; background:#3b82f620; color:#3b82f6; padding:1px 5px; border-radius:9999px; margin-left:4px;">📆 Appt</span>` : "";
      const isTemplate = job.recurrence && job.recurrence !== "none" && !job.parentRecurrenceId;
      const isChildVisit = !!job.parentRecurrenceId;
      const recurBadge = isTemplate
        ? `<span title="Recurring template — spawns visits automatically" style="font-size:0.7rem; background:#a855f720; color:#a855f7; padding:1px 5px; border-radius:9999px; margin-left:4px;">🔁 ${escapeHtml(job.recurrence)}</span>`
        : isChildVisit
          ? `<span title="Auto-generated from a recurring template" style="font-size:0.7rem; background:#a855f714; color:#a855f7; padding:1px 5px; border-radius:9999px; margin-left:4px;">🔁 visit</span>`
          : "";
      const billedBadge = job.invoiceId
        ? `<span title="Rolled into an invoice" style="font-size:0.7rem; background:#10b98120; color:#10b981; padding:1px 5px; border-radius:9999px; margin-left:4px;">✓ billed</span>`
        : "";
      const addressLine = job.serviceAddress
        ? `<div class="small-text">📍 ${escapeHtml(job.serviceAddress)}</div>`
        : "";
      return `
        <div style="padding:0.5rem; border:1px solid var(--border-color); border-radius:0.5rem; background:var(--bg-primary); margin-bottom:0.5rem; ${isLinked ? "border-left:3px solid #3b82f6;" : isTemplate ? "border-left:3px solid #a855f7;" : ""}">
          <div style="font-weight:600; display:flex; align-items:center; flex-wrap:wrap; gap:2px;">${escapeHtml(job.title)}${calBadge}${recurBadge}${billedBadge}</div>
          <div class="small-text">${escapeHtml(job.clientName || job.projectName || "No client")} ${linkedPriceTag}${flatPriceTag}</div>
          ${addressLine}
          <div class="small-text">${job.scheduledDate ? escapeHtml(job.scheduledDate) : "Unscheduled"}${job.assignedTo ? ` · ${escapeHtml(job.assignedTo)}` : ""}</div>
          <div style="display:flex; gap:0.35rem; margin-top:0.4rem;">
            <select onchange="updateJobStatus('${escapeJsSingleQuoted(job.id)}', this.value)" style="flex:1; padding:0.25rem;">
              <option value="backlog" ${job.status === "backlog" ? "selected" : ""}>Backlog</option>
              <option value="scheduled" ${job.status === "scheduled" ? "selected" : ""}>Scheduled</option>
              <option value="in_progress" ${job.status === "in_progress" ? "selected" : ""}>In Progress</option>
              <option value="done" ${job.status === "done" ? "selected" : ""}>Done</option>
              <option value="canceled" ${job.status === "canceled" ? "selected" : ""}>Canceled</option>
            </select>
            <button class="btn btn-danger btn-sm" onclick="deleteJob('${escapeJsSingleQuoted(job.id)}')">×</button>
          </div>
        </div>
      `;
    }).join("");

    return `
      <div style="min-width:220px; background:var(--bg-secondary); border:1px solid var(--border-color); border-radius:0.5rem; padding:0.5rem;">
        <div style="font-weight:600; margin-bottom:0.5rem;">${col.label} (${items.length})</div>
        ${cards || "<p class='small-text'>No jobs</p>"}
      </div>
    `;
  }).join("");

  container.innerHTML = `
    <p class="small-text" style="margin-bottom:0.75rem; color:var(--text-secondary);">Jobs with a <span style="background:#3b82f620; color:#3b82f6; padding:1px 5px; border-radius:9999px; font-size:0.7rem;">📆 Appt</span> badge are linked to a Schedule appointment. Marking them <strong>Done</strong> auto-completes the appointment and creates an invoice.</p>
    <div style="display:grid; grid-template-columns:repeat(auto-fit,minmax(220px,1fr)); gap:0.75rem;">${html}</div>
  `;
}

async function addJob() {
  const title = document.getElementById("newJobTitle")?.value?.trim() || "";
  const projectName = document.getElementById("newJobProject")?.value?.trim() || "";
  const clientName = document.getElementById("newJobClient")?.value?.trim() || "";
  const serviceAddress = document.getElementById("newJobAddress")?.value?.trim() || "";
  const scheduledDate = document.getElementById("newJobDate")?.value || "";
  const assignedTo = document.getElementById("newJobAssigned")?.value?.trim() || "";
  const notes = document.getElementById("newJobNotes")?.value?.trim() || "";
  const flatAmountRaw = document.getElementById("newJobFlatAmount")?.value || "";
  const recurrence = document.getElementById("newJobRecurrence")?.value || "none";
  const seasonStart = document.getElementById("newJobSeasonStart")?.value || "";
  const seasonEnd = document.getElementById("newJobSeasonEnd")?.value || "";
  if (!title) {
    alert("Job title is required.");
    return;
  }

  const flatAmount = flatAmountRaw === "" ? undefined : Number(flatAmountRaw);
  if (flatAmount !== undefined && (!Number.isFinite(flatAmount) || flatAmount < 0)) {
    alert("Flat amount must be a positive number.");
    return;
  }

  const body = {
    title,
    projectName: projectName || undefined,
    clientName: clientName || undefined,
    serviceAddress: serviceAddress || undefined,
    scheduledDate: scheduledDate || undefined,
    assignedTo: assignedTo || undefined,
    notes: notes || undefined,
    flatAmount,
    status: scheduledDate ? "scheduled" : "backlog",
  };
  if (recurrence && recurrence !== "none") {
    body.recurrence = recurrence;
    if (seasonStart) body.seasonStartMonth = Number(seasonStart);
    if (seasonEnd) body.seasonEndMonth = Number(seasonEnd);
    if (scheduledDate) {
      const dow = new Date(scheduledDate + "T00:00:00Z").getUTCDay();
      body.recurrenceDayOfWeek = dow;
    }
  }

  const response = await fetchWithAuth("/api/jobs", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(body),
  });
  if (!response.ok) {
    const err = await response.json().catch(() => ({}));
    alert(err.error || "Failed to add job");
    return;
  }

  [
    "newJobTitle", "newJobProject", "newJobClient", "newJobAddress",
    "newJobDate", "newJobAssigned", "newJobNotes", "newJobFlatAmount",
  ].forEach((id) => {
    const el = document.getElementById(id);
    if (el) el.value = "";
  });
  const recSel = document.getElementById("newJobRecurrence"); if (recSel) recSel.value = "none";
  const sStart = document.getElementById("newJobSeasonStart"); if (sStart) sStart.value = "";
  const sEnd = document.getElementById("newJobSeasonEnd"); if (sEnd) sEnd.value = "";
  const seasonRow = document.getElementById("newJobSeasonRow"); if (seasonRow) seasonRow.style.display = "none";
  await loadJobs();
}

async function updateJobStatus(id, status) {
  const response = await fetchWithAuth("/api/jobs", {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ id, status }),
  });
  if (!response.ok) {
    alert("Failed to update job status");
    return;
  }

  // If marked done and linked to an appointment, complete it + generate invoice
  if (status === "done") {
    const job = jobs.find((j) => j.id === id);
    if (job && job.appointmentId) {
      const appt = appointments.find((a) => a.id === job.appointmentId);
      if (appt && appt.status === "scheduled") {
        await completeApptSilent(appt);
      }
    }
  }

  await loadJobs();
}

async function deleteJob(id) {
  if (!confirm("Delete this job?")) return;
  const response = await fetchWithAuth("/api/jobs", {
    method: "DELETE",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ id }),
  });
  if (!response.ok) {
    alert("Failed to delete job");
    return;
  }
  await loadJobs();
}

function renderInvoiceHistory() {
  const container = document.getElementById("invoiceHistoryList");
  if (!container) return;
  if (!invoices.length) {
    container.innerHTML = "<p class='small-text'>No invoices saved yet.</p>";
    return;
  }

  container.innerHTML = invoices.slice(0, 20).map((inv) => {
    const statusColor = inv.status === "paid" ? "#047857" : inv.status === "sent" ? "#1d4ed8" : "#6b7280";
    return `
      <div style="padding:0.75rem; border:1px solid var(--border-color); border-radius:0.5rem; margin-bottom:0.5rem;">
        <div style="display:flex; justify-content:space-between; gap:0.75rem; align-items:center;">
          <div>
            <div style="font-weight:600;">${escapeHtml(inv.invoiceNum)} · ${escapeHtml(inv.projectName)}</div>
            <div class="small-text">${escapeHtml(inv.clientName)} · ${escapeHtml(inv.month)}${inv.stateCode ? ` · ${escapeHtml(inv.stateCode)}` : ""}</div>
            <div class="small-text">Subtotal $${Number(inv.subtotal || 0).toFixed(2)} · Tax $${Number(inv.taxAmount || 0).toFixed(2)} · Total $${Number(inv.totalDue || 0).toFixed(2)}</div>
          </div>
          <div style="text-align:right;">
            <div style="font-weight:600; color:${statusColor}; text-transform:uppercase; font-size:0.8rem;">${escapeHtml(inv.status || "draft")}</div>
          </div>
        </div>
      </div>
    `;
  }).join("");
}

function generateInvoice() {
  const invoiceMonthSelect = document.getElementById("invoiceMonthSelect");
  const invoiceClientSelect = document.getElementById("invoiceClientSelect");
  const invoiceStatus = document.getElementById("invoiceStatus");
  const invoicePreview = document.getElementById("invoicePreview");
  const downloadBtn = document.getElementById("downloadInvoiceBtn");
  const invoiceStateSelect = document.getElementById("invoiceStateSelect");
  
  const month = invoiceMonthSelect.value;
  const projectName = invoiceClientSelect.value;
  let stateCode = (invoiceStateSelect?.value || "").toUpperCase();
  
  if (!month || !projectName) {
    alert("Please select both month and client.");
    return;
  }
  
  // Get project data
  const projectBreakdown = getProjectBreakdown(month);
  const project = projects.find(p => p.name === projectName);
  if (!stateCode && project?.clientState && US_STATE_CODES.includes(project.clientState)) {
    stateCode = project.clientState;
    if (invoiceStateSelect) invoiceStateSelect.value = stateCode;
  }
  
  if (!projectBreakdown[projectName]) {
    alert("No sessions found for this project in the selected month.");
    return;
  }
  
  const data = projectBreakdown[projectName];
  const subtotal = Number(data.earned || 0);
  const taxRate = stateCode && taxRatesByState[stateCode] !== undefined ? Number(taxRatesByState[stateCode]) : 0;
  const taxAmount = subtotal * (taxRate / 100);
  const totalDue = subtotal + taxAmount;
  const [year, monthNum] = month.split("-");
  const monthName = new Date(year, parseInt(monthNum) - 1).toLocaleString("default", { month: "long", year: "numeric" });
  
  // Get sessions for this project and month
  const projectSessions = sessions.filter((s) => {
    const date = new Date(s.startTime);
    return s.projectName === projectName && 
           date.getFullYear() === parseInt(year) && 
           date.getMonth() + 1 === parseInt(monthNum);
  }).sort((a, b) => a.startTime - b.startTime);
  
  const invoiceNum = `${year}-${monthNum}-${projectName.substring(0, 3).toUpperCase()}`;
  const today = new Date().toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" });
  
  // Build invoice HTML
  let invoiceHTML = `
    <div class="invoice-sheet" style="background: #ffffff; color: #0f172a; padding: 2rem; border-radius: 0.5rem; font-family: 'Segoe UI', sans-serif; line-height: 1.6; max-width: 800px; margin: 0 auto; box-shadow: 0 2px 8px rgba(0,0,0,0.08);">
      <!-- Header -->
      <div class="rule" style="display: flex; justify-content: space-between; align-items: start; margin-bottom: 2rem; border-bottom: 3px solid #0891b2; padding-bottom: 1rem;">
        <div>
          <h1 class="accent" style="margin: 0; color: #0891b2; font-size: 1.75rem;">INVOICE</h1>
          <p class="muted" style="margin: 0.5rem 0 0; color: #64748b; font-size: 0.9rem;">Invoice #: ${invoiceNum}</p>
        </div>
        <div style="text-align: right;">
          <p style="margin: 0; font-weight: 600;">${COMPANY_NAME}</p>
          <p class="muted" style="margin: 0.25rem 0; font-size: 0.9rem; color: #64748b;">Garland, TX</p>
          <p class="muted" style="margin: 0.25rem 0; font-size: 0.9rem; color: #64748b;">Invoice Date: ${today}</p>
        </div>
      </div>

      <!-- Bill To -->
      <div style="display: grid; grid-template-columns: 1fr 1fr; gap: 2rem; margin-bottom: 2rem;">
        <div>
          <p style="margin: 0; font-weight: 600; margin-bottom: 0.5rem;">Bill To:</p>
          <p style="margin: 0; font-size: 0.95rem;">${project ? project.clientName : projectName}</p>
          <p class="muted" style="margin: 0.25rem 0 0; font-size: 0.9rem; color: #64748b;">${project ? project.name : ''}</p>
        </div>
        <div style="text-align: right;">
          <p style="margin: 0; font-weight: 600; margin-bottom: 0.5rem;">Period:</p>
          <p style="margin: 0; font-size: 0.95rem;">${monthName}</p>
        </div>
      </div>

      <!-- Items Table -->
      <div style="margin-bottom: 2rem;">
        <table style="width: 100%; border-collapse: collapse;">
          <thead>
            <tr style="background: #0891b2; color: white;">
              <th style="padding: 0.75rem; text-align: left; font-weight: 600;">Date</th>
              <th style="padding: 0.75rem; text-align: left; font-weight: 600;">Description</th>
              <th style="padding: 0.75rem; text-align: right; font-weight: 600;">Hours</th>
              <th style="padding: 0.75rem; text-align: right; font-weight: 600;">Rate</th>
              <th style="padding: 0.75rem; text-align: right; font-weight: 600;">Amount</th>
            </tr>
          </thead>
          <tbody>
  `;
  
  projectSessions.forEach((s) => {
    const date = new Date(s.startTime).toLocaleDateString("en-US", { month: "short", day: "numeric" });
    const description = s.notes || "Professional services";
    const hours = (s.hours || 0).toFixed(2);
    const rate = s.rate;
    const amount = (s.earned || 0).toFixed(2);
    
    invoiceHTML += `
      <tr style="border-bottom: 1px solid #e2e8f0;">
        <td style="padding: 0.75rem; font-size: 0.9rem;">${date}</td>
        <td style="padding: 0.75rem; font-size: 0.9rem;">${description}</td>
        <td style="padding: 0.75rem; text-align: right; font-size: 0.9rem;">${hours}</td>
        <td style="padding: 0.75rem; text-align: right; font-size: 0.9rem;">$${rate}/hr</td>
        <td style="padding: 0.75rem; text-align: right; font-size: 0.9rem;">$${amount}</td>
      </tr>
    `;
  });
  
  invoiceHTML += `
          </tbody>
        </table>
      </div>

      <!-- Summary -->
      <div style="display: flex; justify-content: flex-end; margin-bottom: 2rem;">
        <div style="width: 300px;">
          <div class="summary-box" style="display: grid; grid-template-columns: 1fr 1fr; gap: 1rem; padding: 1rem; background: #f1f5f9; border-radius: 0.375rem;">
            <div style="text-align: right;">
              <p style="margin: 0; font-weight: 600;">Subtotal:</p>
            </div>
            <div style="text-align: right;">
              <p style="margin: 0; font-weight: 600;">$${subtotal.toFixed(2)}</p>
            </div>
            <div style="text-align: right;">
              <p style="margin: 0; font-weight: 600;">Tax${stateCode ? ` (${stateCode} ${taxRate.toFixed(2)}%)` : ""}:</p>
            </div>
            <div style="text-align: right;">
              <p style="margin: 0; font-weight: 600;">$${taxAmount.toFixed(2)}</p>
            </div>
            <div class="rule-light" style="text-align: right; padding-top: 0.5rem; border-top: 1px solid #cbd5e1;">
              <p style="margin: 0; font-weight: 600; font-size: 1.1rem;">Total Due:</p>
            </div>
            <div class="rule-light" style="text-align: right; padding-top: 0.5rem; border-top: 1px solid #cbd5e1;">
              <p class="accent" style="margin: 0; font-weight: 600; font-size: 1.1rem; color: #0891b2;">$${totalDue.toFixed(2)}</p>
            </div>
          </div>
        </div>
      </div>

      <!-- Footer -->
      <div class="rule-light" style="border-top: 2px solid #e2e8f0; padding-top: 1.5rem; font-size: 0.85rem; color: #64748b;">
        <p style="margin: 0; margin-bottom: 0.5rem; font-weight: 600;">Payment Terms:</p>
        <p style="margin: 0; margin-bottom: 1.5rem;">Net 30 days from invoice date</p>
        
        <div style="display: flex; gap: 1rem; margin-bottom: 1rem;">
          <button onclick="createStripePaymentLink('${invoiceNum}', ${totalDue}, '${project ? project.clientName : projectName}', '${stateCode}', ${taxRate}, ${taxAmount})" class="btn btn-success" style="flex: 1;">💳 Pay Now</button>
          <button onclick="sendInvoiceEmail('${projectName}', '${monthName}')" class="btn btn-primary" style="flex: 1;">✉️ Email Invoice</button>
        </div>
        
        <p class="muted" style="margin: 0; color: #94a3b8;">Thank you for your business!</p>
      </div>
    </div>
  `;
  
  invoicePreview.innerHTML = invoiceHTML;
  invoicePreview.style.display = "block";
  downloadBtn.style.display = "inline-block";
  invoiceStatus.textContent = "Generated ✓";
  
  // Store for download
  window.currentInvoice = {
    html: invoiceHTML,
    projectName: projectName,
    clientName: project ? project.clientName : projectName,
    month: monthName,
    invoiceNum: invoiceNum,
    subtotal,
    stateCode,
    taxRate,
    taxAmount,
    totalDue,
  };

  saveCurrentInvoiceRecord({
    invoiceNum,
    projectName,
    clientName: project ? project.clientName : projectName,
    month: monthName,
    subtotal,
    taxAmount,
    totalDue,
    stateCode,
    taxRate,
    status: "draft",
  });
}

function downloadInvoicePDF() {
  if (!window.currentInvoice) {
    alert("Generate an invoice first.");
    return;
  }
  
  const { html, projectName, invoiceNum } = window.currentInvoice;
  
  // Create a new window for printing
  const printWindow = window.open("", "", "width=800,height=600");
  printWindow.document.write(`
    <!DOCTYPE html>
    <html>
      <head>
        <title>Invoice - ${invoiceNum}</title>
        <style>
          body { font-family: 'Segoe UI', sans-serif; margin: 0; padding: 1rem; background: #f9fafb; }
          @media print {
            body { padding: 0; background: white; }
            button { display: none; }
          }
        </style>
      </head>
      <body>
        <button onclick="window.print(); return false;" style="margin-bottom: 1rem; padding: 0.5rem 1rem; background: #0891b2; color: white; border: none; border-radius: 0.375rem; cursor: pointer; font-size: 0.9rem;">
          Print / Save as PDF
        </button>
        ${html}
      </body>
    </html>
  `);
  printWindow.document.close();
}

function clearCleanupUI() {
  const cleanupSuggestions = document.getElementById("cleanupSuggestions");
  const cleanupStatus = document.getElementById("cleanupStatus");
  if (cleanupSuggestions) cleanupSuggestions.innerHTML = "";
  if (cleanupStatus) cleanupStatus.style.display = "none";
  storedCleanupSuggestions = [];
}

// ========== Payment & Email Functions ==========
async function createStripePaymentLink(invoiceNum, amount, clientName, stateCode = "", taxRate = 0, taxAmount = 0) {
  try {
    // Call backend to create payment link
    const response = await fetchWithAuth("/api/create-payment-link", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        invoiceNum,
        amount: Math.round(amount * 100), // Convert to cents
        clientName,
        description: `Invoice ${invoiceNum} - ${clientName}`,
        state: stateCode || undefined,
        taxRate,
        taxAmount: Math.round(Number(taxAmount || 0) * 100),
      })
    });

    if (!response.ok) {
      const err = await response.json().catch(() => ({}));
      throw new Error(err.error || "Failed to create payment link");
    }
    
    const data = await response.json();
    
    if (data.paymentUrl) {
      // Open payment link in new window or redirect
      window.open(data.paymentUrl, "_blank");
    } else {
      alert("Error creating payment link. Check console.");
    }
  } catch (err) {
    console.error("Payment link error:", err);
    alert("Failed to create payment link: " + err.message);
  }
}

async function sendInvoiceEmail(projectName, monthName) {
  try {
    // Find the project for client email
    const project = projects.find(p => p.name === projectName);
    if (!project) {
      alert("Project not found");
      return;
    }

    // Resolve recipient: prefer linked Client.email → fallback to denormalized project.clientEmail.
    const linkedClient = project.clientId ? clients.find((c) => c.id === project.clientId) : null;
    const defaultTo = ((linkedClient && linkedClient.email) || project.clientEmail || "").trim();
    const promptMsg = defaultTo
      ? `Send invoice for "${projectName}" to:`
      : `Send invoice for "${projectName}" to which email address?`;
    const toEmail = (prompt(promptMsg, defaultTo) || "").trim();
    if (!toEmail) return;

    // Optional override of sender (server picks from company allowlist if blank).
    const fromEmail = (localStorage.getItem("fromEmail") || "").trim();

    // Call backend to send email
    const response = await fetchWithAuth("/api/send-invoice", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        projectName,
        monthName,
        toEmail,
        fromEmail,
        invoiceHtml: window.currentInvoice ? window.currentInvoice.html : ""
      })
    });

    const result = await response.json().catch(() => ({}));
    if (!response.ok || result.success === false) {
      throw new Error(result.error || `HTTP ${response.status}`);
    }

    if (window.currentInvoice?.invoiceNum) {
      await fetchWithAuth("/api/invoices", {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ invoiceNum: window.currentInvoice.invoiceNum, status: "sent" }),
      });
      await loadInvoices();
    }

    alert(`✓ Invoice emailed to ${toEmail}` + (result.fromEmail ? ` from ${result.fromEmail}` : ""));
  } catch (err) {
    console.error("Email send error:", err);
    alert("Failed to send email: " + err.message);
  }
}
